module.exports = __webpack_public_path__ + "images/emoji/ship.ad130a6a4fdaf267a2e7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ship.png
// module id = 7JSX
// module chunks = 24